import {
  DashboardDataTableColumnKind,
  buildDashboardDataTableColumns,
} from '@shigo-ui/dashboard-ui';

import { dashboardT } from '../../../../../lib/messages';
import { manageDialogFetchSize } from '../../../../../lib/clientSelectionList';
import { useTailoredSuppliesQuery } from '../../hooks';
import { type TailoredSupply } from '../../model';
import { SelectionDialog, type SelectionColumnOptions } from './ManageSupplySelectionDialog';

const tailoredSupplyLookupFilter = {
  searchTerm: '',
  page: 0,
  size: manageDialogFetchSize,
};

export function ManageTailoredSuppliesDialog({
  open,
  selectedItems,
  onOpenChange,
  onConfirm,
}: {
  open: boolean;
  selectedItems: TailoredSupply[];
  onOpenChange: (open: boolean) => void;
  onConfirm: (items: TailoredSupply[]) => void;
}) {
  const query = useTailoredSuppliesQuery(tailoredSupplyLookupFilter, open);
  return (
    <SelectionDialog
      open={open}
      title={dashboardT('targeting.tailoredSupply')}
      description={dashboardT('madBuy.supply.tailored.manageDescription')}
      items={query.data?.content ?? []}
      selectedItems={selectedItems}
      columns={buildTailoredSupplySelectionColumns}
      minWidthClassName="min-w-[520px]"
      loading={query.isLoading}
      errorMessage={query.isError ? dashboardT('supply.loadError') : undefined}
      getId={(item) => item.id}
      searchText={(item) => item.name}
      onOpenChange={onOpenChange}
      onConfirm={onConfirm}
    />
  );
}

function buildTailoredSupplySelectionColumns({
  selectedIds,
  onToggleSelection,
  headerChecked,
  headerDisabled,
  headerLabel,
  onHeaderChange,
}: SelectionColumnOptions<TailoredSupply>) {
  return buildDashboardDataTableColumns<TailoredSupply>([
    {
      kind: DashboardDataTableColumnKind.Selection,
      id: 'select',
      header: '',
      checked: (item) => selectedIds.has(item.id),
      label: (item) => dashboardT('supply.selectNamed', { name: item.name }),
      onChange: onToggleSelection,
      headerChecked,
      headerDisabled,
      headerLabel,
      onHeaderChange,
    },
    {
      kind: DashboardDataTableColumnKind.Text,
      id: 'name',
      header: dashboardT('supply.name'),
      className: 'font-medium',
      value: (item) => item.name,
    },
  ]);
}
